"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _BackgroundContainerLogic = require("./BackgroundContainerLogic");
var _BackgroundTasks = _interopRequireDefault(require("./BackgroundTasks"));
var _BackgroundContext = require("@/context/BackgroundContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BackgroundContainer = function BackgroundContainer(_ref) {
  var tasks = _ref.tasks,
    onDismissTask = _ref.onDismissTask,
    callbackRefetch = _ref.callbackRefetch;
  var validateItemsOfTask = function validateItemsOfTask(task) {
    var type = task.type,
      tasks = task.tasks;
    return tasks.map(function (taskItem) {
      var file = taskItem.file,
        response = taskItem.response;
      if (response) {
        if (type === _BackgroundContext.UPLOAD_TASK) {
          return _objectSpread(_objectSpread({}, file), (0, _BackgroundContainerLogic.getManualTaskConfig)(taskItem));
        }
        if (type === _BackgroundContext.UPLOAD_TEAMS_TASK) {
          return _objectSpread(_objectSpread({}, file), (0, _BackgroundContainerLogic.getTeamsTaskConfig)(taskItem));
        }
      }
      return _objectSpread(_objectSpread({}, file), {}, {
        status: _BackgroundContainerLogic.IN_PROGRESS_STATUS,
        text: "Upload in progress"
      });
    });
  };
  var validateTask = function validateTask(task) {
    var _task$tasks;
    //We need to validate
    // Task status (it should return the status, icon and tooltip message)
    // With this, we can define the general task status
    var failedIcon = /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "material-symbols:warning",
      color: "#FF9905"
    });
    var progressIcon = /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
      size: 12
    });
    var completedIcon = /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "carbon:checkmark-filled",
      color: "green"
    });
    var errorIcon = /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "material-symbols:warning",
      color: "red"
    });
    var title = "".concat(task.type, " (").concat((_task$tasks = task.tasks) === null || _task$tasks === void 0 ? void 0 : _task$tasks.length, ")");
    var icon = progressIcon;
    var validatedItems = validateItemsOfTask(task);
    var uncompletedTasks = validatedItems.some(function (vI) {
      return vI.status === _BackgroundContainerLogic.IN_PROGRESS_STATUS;
    });
    if (!uncompletedTasks) {
      var successfulItems = validatedItems.filter(function (item) {
        return item.status === _BackgroundContainerLogic.COMPLETED_PROGRESS_STATUS || item.status === _BackgroundContainerLogic.FAILED_DURING_CONVERSION;
      });
      if (successfulItems.length > 0) {
        callbackRefetch();
      }
      if (validatedItems.some(function (item) {
        return item.status === _BackgroundContainerLogic.FAILED_PROGRESS_STATUS || item.status === _BackgroundContainerLogic.FAILED_DURING_CONVERSION;
      })) {
        icon = failedIcon;
      } else {
        icon = completedIcon;
      }
      title = "Files uploaded (".concat(successfulItems.length, "/").concat(validatedItems.length, ")");
    }
    return {
      completed: !uncompletedTasks,
      titleIcon: icon,
      titleText: title,
      items: validatedItems.map(function (item) {
        var status = item.status,
          name = item.name,
          text = item.text;
        var icon = progressIcon;
        if (status === _BackgroundContainerLogic.COMPLETED_PROGRESS_STATUS) {
          icon = completedIcon;
        } else if (status === _BackgroundContainerLogic.FAILED_DURING_CONVERSION) {
          icon = failedIcon;
        } else if (status === _BackgroundContainerLogic.FAILED_PROGRESS_STATUS) {
          icon = errorIcon;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex gap-5 align-items-center",
          key: name
        }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
          arrow: true,
          title: text
        }, icon), /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
          arrow: true,
          title: name
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-overflow-ellipsis",
          style: {
            maxWidth: "80%",
            width: "80%"
          }
        }, name)));
      })
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      padding: "5px",
      display: "flex",
      flexDirection: "column-reverse",
      rowGap: "5px",
      position: "absolute",
      right: "2%",
      bottom: "10%",
      width: "15vw",
      maxHeight: "50vh",
      overflowY: "auto"
    }
  }, tasks.map(function (task) {
    var id = task.id;
    var _validateTask = validateTask(task),
      titleText = _validateTask.titleText,
      titleIcon = _validateTask.titleIcon,
      items = _validateTask.items,
      completed = _validateTask.completed;
    return /*#__PURE__*/_react["default"].createElement(_BackgroundTasks["default"], {
      key: id,
      id: id,
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex gap-5 align-items-center"
      }, titleIcon, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex space-between",
        style: {
          width: "100%",
          marginRight: "10px"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex gap-5 align-items-center"
      }, /*#__PURE__*/_react["default"].createElement("span", null, titleText)), completed && /*#__PURE__*/_react["default"].createElement("button", {
        title: "Dismiss",
        className: "btn-default btn-default-style",
        onClick: function onClick(e) {
          e.preventDefault();
          onDismissTask(id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
        icon: "material-symbols:close-rounded"
      }))))
    }, items);
  }));
};
var _default = exports["default"] = BackgroundContainer;